import { createFileRoute } from '@tanstack/react-router';
import Profile from '@src/pages/Profile';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/profile')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('profile.page_title', 'My Profile') }],
  }),
  component: Profile,
});
